import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import HomeLayout from '../../Layout/HomeLayout';
import HomeHeader from '../../CustomComponents/HomeHeader';
import Checking from '../Checking';
import Savings from '../Savings';
import { CHECKING_CARD_CODE, SAVING_CARD_CODE } from '../../../helpers/utils/Utils';
import { addLineBreaks } from '../../../utils';

const Transactions = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const cards = useSelector(state => JSON.parse(state.userCards));
  const [accountType, setAccountType] = useState('spending'); // default to spending

  // Determine if user has spending or savings account
  const hasSpendingAccount = cards?.some(card => card.AccountTypeBit63 === CHECKING_CARD_CODE);
  const hasSavingsAccount = cards?.some(card => card.AccountTypeBit63 === SAVING_CARD_CODE);

  useEffect(() => {
    // Get account type from location state or default to spending
    if (location.state?.accountType) {
      setAccountType(location.state.accountType);
    } else if (hasSpendingAccount) {
      setAccountType('spending');
    } else if (hasSavingsAccount) {
      setAccountType('savings');
    }
  }, [location.state, hasSpendingAccount, hasSavingsAccount]);

  const handleAccountSwitch = (selectedAccountType) => {
    setAccountType(selectedAccountType);
  };

  const getHeaderText = () => {
    return addLineBreaks(
      t('basic_account_sideHeading').replace("{TYPE}", accountType)
    );
  };

  return (
    <HomeLayout>
      <HomeHeader heading={getHeaderText()} isHeaderCaption={true} />
      <div className='flex flex-col lg:w-[860px] md:w-[860px] sm:w-[464px] w-[100%] animate__animated animate__fadeInRight'>
        {accountType === 'spending' && hasSpendingAccount ? (
          <Checking 
            key="spending-transactions"
            hideLayout={true} 
            Radius={true} 
            isTransactionsPage={true}
            onAccountSwitch={handleAccountSwitch}
            hasSpendingAccount={hasSpendingAccount}
            hasSavingsAccount={hasSavingsAccount}
          />
        ) : accountType === 'savings' && hasSavingsAccount ? (
          <Savings 
            key="savings-transactions"
            hideLayout={true} 
            Radius={true}
            isTransactionsPage={true}
            onAccountSwitch={handleAccountSwitch}
            hasSpendingAccount={hasSpendingAccount}
            hasSavingsAccount={hasSavingsAccount}
          />
        ) : (
          <div className="text-center p-8">
            <p>{t('no_account_available')}</p>
          </div>
        )}
      </div>
    </HomeLayout>
  );
};

export default Transactions;
